import { Table as MantineTable } from '@mantine/core';
import { forwardRef } from 'react';
import { clx } from './clx';
import classes from './table.module.css';
export const GoodTableTr = forwardRef(({ children, ...props }, ref) => {
    return (<MantineTable.Tr ref={ref} {...props} className={clx(classes.tableTr, props.className)}>
      {children}
    </MantineTable.Tr>);
});
